export const SEARCH_PLACEHOLDER = 'Find by process, error, or who triggered…';

export const PAGER_SHOWING_TEMPLATE = ({ from, to, total }) =>
  total === 0 ? 'No runs to show' : `Showing ${from}–${to} of ${total}`;

export const EMPTY_STATE_TITLE = 'Nothing matches';

export const EMPTY_STATE_SUBTITLE =
  'Try clearing the search or removing a filter chip to see more runs.';

export const CLEAR_FILTERS_LABEL = 'Clear filters';

export const FIRST_RUN_TITLE = 'No AI activity yet';

export const FIRST_RUN_SUBTITLE = "When an AI process runs on this loan, it'll show up here.";

export const START_PROCESS_LABEL = 'Start an AI process';

export const ERROR_STATE_TITLE = "Couldn't load runs";

export const ERROR_STATE_SUBTITLE = 'Something went wrong fetching this loan’s AI activity.';

export const RETRY_LABEL = 'Retry';

export const RUN_SKELETON_ROW_COUNT = 5;

export const RUN_SKELETON_ROW_HEIGHT = 64;

export const SAVED_CHIP_LABEL_PREFIX = 'Quick filters:';

const NEEDS_REVIEW_CHIP_BASE_LABEL = 'Needs review';

export const formatNeedsReviewChipLabel = count =>
  count > 0 ? `${NEEDS_REVIEW_CHIP_BASE_LABEL} (${count})` : NEEDS_REVIEW_CHIP_BASE_LABEL;
